import type { AppData, DriverProfile, NotificationSettings } from "@/types/tax";

export const defaultNotificationSettings: NotificationSettings = {
  monthlyUploadEnabled: true,
  basDueEnabled: true,
  basDueLeadDays: 7,
  timezone: "Australia/Brisbane",
  pushEnabled: false,
};

export const emptyProfile: DriverProfile = {
  id: "",
  displayName: "",
  email: "",
  plan: "free",
  manualPlan: "free",
  planSource: "free",
  subscriptionStatus: null,
  subscriptionRenewsAt: null,
  subscriptionCancelAt: null,
  billingManagementAvailable: false,
  scanQuotaLimit: 0,
  scanQuotaUsed: 0,
  scanQuotaRemaining: 0,
  scanQuotaResetAt: null,
  abn: "",
  gstRegistrationDate: "",
  basFrequency: "quarterly",
  defaultBusinessUsePercent: 100,
  vehicleNotes: "",
  hasConfirmedBasOnly: true,
  notificationSettings: defaultNotificationSettings,
};

export const emptyAppData: AppData = {
  profile: emptyProfile,
  incomeSummaries: [],
  documents: [],
  expenses: [],
  annualTaxSettings: [],
  annualTaxAdjustments: [],
};
